import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { AbsolutePositioned } from '../../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Screen, SplitScreen } from '../../../../components/Layout/Screen';
import Counter from '../../../../components/Counter';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import Title, { Subtext } from '../../../../components/Title';
import background from '../../../../assets/images/pages/patient-hope/sanofi-genzyme-logo.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
`;

const StyledSplitScreen = SplitScreen.extend`
  height: 50%;
  vertical-align: top;
`;

const StyledContentContainer = ContentContainer.extend`
  padding: 30px 10px 0;
  @media ${device.tablet} {
    padding: 30px 40px;
  }
`;

const CounterContainer = styled.div`
  max-width: 470px;
  margin: 89px 0 0 0;
  width: 100%;
  padding: 0 6px;
  @media ${device.tablet} {
    margin: 144px 0 0 0;
  }
  @media ${device.laptop} {
    margin: 66px 0 0 0;
  }

  .counter {
    font-size: 80px;
    line-height: 141px;
  }

  h1.counter {
    font-size: 16px;
    line-height: 24px;
    @media ${device.tablet} {
      line-height: 39px;
      font-size: 24px;
    }
  }

  .title {
    text-align: center;
    width: 100%;
    position: relative;

    h2 {
      margin: 0 auto;
      font-size: 24px;
      line-height: 34px;
      @media ${device.tablet} {
        width: 307px;
        font-size: 36px;
        line-height: 42px;
      }
    }

    div {
      margin: 0 auto;
      font-size: 16px;
      line-height: 21px;
      max-width: 470px;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: -62px;
      @media ${device.tablet} {
        line-height: 39px;
        font-size: 24px;
      }
    }
  }
`;

const BackgroundImage = AbsolutePositioned.extend`
  background: url(${background}) center no-repeat;
  background-size: 102px;
  top: 25px;
  width: 100%;
  height: 100%;
  @media ${device.tablet} {
    background-size: 170px;
  }
`;

const CounterScreen = () => (
  <StyledScreen className="counter-screen">
    <AbsolutePositioned bottom="0" right="0">
      <StyledSplitScreen background={brandColors.yellow} />
      <StyledSplitScreen background={brandColors.grey} />
      <StyledSplitScreen background={brandColors.white} />
      <StyledSplitScreen background={brandColors.orange} />
    </AbsolutePositioned>
    <BackgroundImage />
    <AbsolutePositioned bottom="0" right="0">
      <StyledContentContainer>
        <StyledSplitScreen>
          <CounterContainer>
            <Counter
              className="counter"
              maxCount={90}
              title="of users rated 'Very good' or 'Excellent'"
              color={brandColors.blue}
              addSymbol="%"
            />
          </CounterContainer>
        </StyledSplitScreen>
        <StyledSplitScreen>
          <CounterContainer>
            <Title className="title" primary={false}>
              Well presented, easy to follow, and interactive set of online modules.
              <Subtext>Sales Manager, Sanofi</Subtext>
            </Title>
          </CounterContainer>
        </StyledSplitScreen>
        <StyledSplitScreen>
          <CounterContainer>
            <Title className="title" primary={false}>
              The levels of knowledge, and importantly confidence, of the whole team was sky high!
              <Subtext>Sales Manager, Sanofi</Subtext>
            </Title>
          </CounterContainer>
        </StyledSplitScreen>
        <StyledSplitScreen>
          <CounterContainer>
            <Counter
              className="counter"
              maxCount={109}
              title="custom illustrations"
              color={brandColors.blue}
            />
          </CounterContainer>
        </StyledSplitScreen>
      </StyledContentContainer>
    </AbsolutePositioned>
  </StyledScreen>
);

export default connect()(CounterScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/AdvocatingForPatientsHope/screens/Counter.jsx